import { updateObject } from "../utility";
import {
  SAVE_BRAND_YARAGH_LIST,
  SAVE_BAZSHO_LIST,
  SAVE_HALAT_LIST,
  SAVE_ARSHIV_BRAND_DATA,
  SAVE_YARAGH_COUNTRY,
  SELECT_BRAND_YARAGH,
  SAVE_MAHDOODE_DATA,
  SAVE_MAHDOODEFANI_DATA,
  ACTION_GET_BRAND_YARAGH_RELATION,
  ACTION_GET_BAZSHO_YARAGH_RELATION,
  SELECT_BAZSHO,
  MAHDOODE_SEARCH,
  SEARCHBRANDFITTING,
  SEARCHPOP,
  SAVENEWSTUFF,
  SAVENEWSTUFF_ROK
} from "Stores/actionTypes";

const initialState = {
  brandYaraghList: null,
  bazshoList: null,
  halatList: null,
  arshivBrandData: [],
  yaraghCountry: null,
  selectedBrandYaragh: null,
  selectedBazsho: null,
  mahdoodeData: [],
  mahdoodeDataPagination: { Limit: 10, Page: 1, Total: 0 },
  mahdoodeDataSearch: null,
  arshivBrandDataPagination: { Limit: 10, Page: 1, Total: 0 },
  isWidth: false,
  isHeight: false,
  dataRelationBrand: [],
  dataRelationBazsho: [],
  brandYaraghSearch: "",
  bazshoYaraghSearch: "",
  mahdoodeFani: [],
  mahdoodeFaniPagination: { Limit: 10, Page: 1, Total: 0 },
  isWidthFani: false,
  isHeightFani: false,
  refresh_stuff_list: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MAHDOODE_SEARCH: return updateObject(state, { mahdoodeDataSearch: action.mahdoodeDataSearch, });
    case SELECT_BAZSHO: return updateObject(state, { selectedBazsho: action.selectedBazsho });
    case SAVE_MAHDOODE_DATA: return updateObject(state, {
      mahdoodeData: action.mahdoodeData,
      mahdoodeDataPagination: action.mahdoodeDataPagination,
      isWidth: action.isWidth,
      isHeight: action.isHeight,
    });
    case SAVE_MAHDOODEFANI_DATA: return updateObject(state, {
      mahdoodeFani: action.mahdoodeFani,
      mahdoodeFaniPagination: action.mahdoodeFaniPagination,
      isWidthFani: action.isWidthFani,
      isHeightFani: action.isHeightFani,
    });
    case SAVENEWSTUFF: return updateObject(state, { refresh_stuff_list: true });
    case SAVENEWSTUFF_ROK: return updateObject(state, { refresh_stuff_list: false });
    case SELECT_BRAND_YARAGH:
      return updateObject(state, {
        selectedBrandYaragh: action.selectedBrandYaragh,
      });
    case SAVE_YARAGH_COUNTRY:
      return updateObject(state, { yaraghCountry: action.yaraghCountry });
    case SAVE_ARSHIV_BRAND_DATA:
      return updateObject(state, {
        arshivBrandData: action.arshivBrandData,
        arshivBrandDataPagination: action.arshivBrandDataPagination,
      });
    case SAVE_HALAT_LIST:
      return updateObject(state, { halatList: action.halatList });
    case SAVE_BAZSHO_LIST:
      return updateObject(state, { bazshoList: action.bazshoList });
    case SAVE_BRAND_YARAGH_LIST:
      return updateObject(state, {
        brandYaraghList: action.brandYaraghList,
        selectedBrandYaragh: action.selectedBrandYaragh,
      });
    case ACTION_GET_BRAND_YARAGH_RELATION:
      return updateObject(state, {
        dataRelationBrand: action.dataRelationBrand,
      });
    case ACTION_GET_BAZSHO_YARAGH_RELATION:
      return updateObject(state, {
        dataRelationBazsho: action.dataRelationBazsho,
      });
    case SEARCHBRANDFITTING:
      return updateObject(state, { brandYaraghSearch: action.data });
    case SEARCHPOP:
      return updateObject(state, { bazshoYaraghSearch: action.data });
    default:
      return state;
  }
};

export default reducer;
